/* eslint-disable no-param-reassign  */
import { createSlice } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import StatesRepository from 'repositories/loanOfficer/StatesRepository';

const initialState = {
  loading: false,
  states: [],
};

const statesSlice = createSlice({
  name: 'statesSlice',
  initialState,
  reducers: {
    loadStatesStart(state) {
      state.loading = true;
    },
    loadStatesSuccess(state, { payload }) {
      const { data } = payload;
      state.states = data;
      state.loading = false;
    },
    loadStatesFail(state) {
      state.loading = false;
    },
  },
});

export const { actions } = statesSlice;

export default statesSlice.reducer;

export const useAppActions = () => {
  const dispatch = useDispatch();

  const loadStates = async params => {
    dispatch(actions.loadStatesStart());
    try {
      const response = await StatesRepository.index(params);
      dispatch(actions.loadStatesSuccess(response));
      return Promise.resolve();
    } catch (_error) {
      dispatch(actions.loadStatesFail());
      return Promise.reject();
    }
  };

  return {
    loadStates,
  };
};
/* eslint-enable no-param-reassign */



// WEBPACK FOOTER //
// ./src/reducers/slices/statesSlice.js